export const FETCH_EVENT_ROLE_TYPES_BEGIN = 'FETCH_EVENT_ROLE_TYPES_BEGIN';
export const FETCH_EVENT_ROLE_TYPES_ERROR = 'FETCH_EVENT_ROLE_TYPES_ERROR';
export const FETCH_EVENT_ROLE_TYPES_SUCCESS = 'FETCH_EVENT_ROLE_TYPES_SUCCESS';
